(function () {
    "use strict";
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular.module("edistradaIdealeasingPortalApp")
.constant("ENV", "prod")
.constant("API_URL", "../ilapi/")
.constant("VERSION", "132.0.0-14-g0a226ad");

})();
